import { styled } from '@vw-marketing/us-components';

export const MatchInformationContainer: any = styled.div`
  width: 100%;
  padding-bottom: 60px;
`;

export const ButtonContainer: any = styled.div`
  width: 100%;
  margin-bottom: 10px;
`;
